import { types } from 'mobx-state-tree';

import { IsoDate, EmailAddress, PROVINCES } from '../../../common/v1';


const Agent = types
    .model('Agent', {
        agentID: types.identifier,
        firstName: types.maybe(types.string),
        lastName: types.maybe(types.string),
        dob: types.maybe(IsoDate),
        email: types.maybe(EmailAddress),
        primaryPhone: types.maybe(types.string),
        primaryExt: types.maybe(types.string),
        secondaryPhone: types.maybe(types.string),
        secondaryExt: types.maybe(types.string),
        selectable: types.optional(types.boolean, false),
        city: types.maybe(types.string),
        provinces: types.array(types.model({
            // Expected to be a member of our provinces enum
            id: types.refinement(types.identifier, id => Object.values(PROVINCES).includes(id)),
            description: types.maybe(types.string),
            description_en: types.maybe(types.string),
            description_fr: types.maybe(types.string),
            filogixID: types.maybe(types.integer),
        })),
        title: types.optional(types.string, ''),
        title_fr: types.optional(types.string, ''),
        bio_en: types.optional(types.string, ''),
        bio_fr: types.optional(types.string, ''),
        testimonialName_en: types.optional(types.string, ''),
        testimonialName_fr: types.optional(types.string, ''),
        testimonial_en: types.optional(types.string, ''),
        testimonial_fr: types.optional(types.string, ''),
        fl_firm: types.optional(types.string, ''),
        fl_login: types.optional(types.string, ''),
        fl_agentid: types.optional(types.string, ''),
        calendarID: types.optional(types.string, ''),
        hideFromRatehubAgentPage: types.optional(types.boolean, false),
    })
    .views(self => ({
        get fullName() {
            return `${self.firstName} ${self.lastName}`;
        },
    }));

export default Agent;
